export const STORE_CONFIG = {
  name: "ROMI STORE EC",
  whatsapp: "593994683079",
  country: "Ecuador",
  currency: "USD",
};

export const buildWhatsAppUrl = (message = "") => {
  const baseUrl = `https://wa.me/${STORE_CONFIG.whatsapp}`;
  return message ? `${baseUrl}?text=${encodeURIComponent(message)}` : baseUrl;
};
